import React, { useRef, useState } from "react";
import { Box, Typography, IconButton, Button } from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { getVideoUrl, getImageUrl } from "../utils/productMedia";

const MobileReelCard = ({ item, isActive, onNavigate, onAddToCart, onToggle, onBuyProduct, audioEnabled, onToggleAudio, isWishlisted }) => {
  const itemId = item.id || item._id || item.productId;
  const imageUrl = getImageUrl(item);
  const videoUrl = getVideoUrl(item);
  const videoRef = useRef(null);
  const [videoPlaying, setVideoPlaying] = useState(false);

  React.useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoUrl) return;
    video.muted = !audioEnabled;
    if (isActive) { video.currentTime = 0; video.play().catch(() => {}); setVideoPlaying(true); }
    else { video.pause(); setVideoPlaying(false); }
  }, [isActive, videoUrl, audioEnabled]);

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%", bgcolor: "#000", overflow: "hidden" }}>
      {videoUrl ? (
        <video ref={videoRef} src={videoUrl} muted loop playsInline preload="metadata" poster={imageUrl || undefined}
          onClick={() => { if (videoRef.current) { if (videoPlaying) { videoRef.current.pause(); } else { videoRef.current.play().catch(() => {}); } setVideoPlaying(!videoPlaying); } }}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : imageUrl ? (
        <Box component="img" src={imageUrl} alt={item.title} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: 40, opacity: 0.3 }}>📦</Box>
      )}

      {/* Audio Button - always visible if video exists */}
      {videoUrl && (
        <IconButton size="small" onClick={(e) => { e.stopPropagation(); if (onToggleAudio) onToggleAudio(); }}
          sx={{ position: "absolute", top: 150, right: 16, zIndex: 10, bgcolor: "rgba(0,0,0,0.6)", color: "#fff", "&:hover": { bgcolor: "rgba(0,0,0,0.8)" } }}>
          {audioEnabled ? <VolumeUpIcon sx={{ fontSize: 20 }} /> : <VolumeOffIcon sx={{ fontSize: 20 }} />}
        </IconButton>
      )}

      {/* Share Button - same position as ReelCard */}
      <IconButton size="small" onClick={(e) => { e.stopPropagation(); if (navigator.share) { navigator.share({ title: item.title, url: `${window.location.origin}/product/${itemId}` }).catch(() => {}); } else { navigator.clipboard.writeText(`${window.location.origin}/product/${itemId}`).catch(() => {}); } }}
        sx={{ position: "absolute", top: 200, right: 16, zIndex: 10, bgcolor: "rgba(0,0,0,0.6)", color: "#fff", "&:hover": { bgcolor: "rgba(0,0,0,0.8)" } }}>
        <ShareIcon sx={{ fontSize: 20 }} />
      </IconButton>

      {/* Wishlist Button - same position as ReelCard */}
      <IconButton size="small" onClick={(e) => { e.stopPropagation(); if (onToggle) onToggle(item); }}
        sx={{ position: "absolute", top: 250, right: 16, zIndex: 10, bgcolor: "rgba(0,0,0,0.6)", color: "#fff", "&:hover": { bgcolor: "rgba(0,0,0,0.8)" } }}>
        {isWishlisted ? <FavoriteIcon sx={{ fontSize: 20, color: "#ef4444" }} /> : <FavoriteBorderIcon sx={{ fontSize: 20, color: "#fff" }} />}
      </IconButton>

      <Box sx={{ position: "absolute", bottom: 0, left: 0, right: 0, height: "35%", background: "linear-gradient(to top, rgba(0,0,0,0.85), transparent)" }} />
      <Box sx={{ position: "absolute", bottom: 0, left: 0, right: 0, p: 1.5 }}>
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: 14, mb: 0.3 }}>{item.title}</Typography>
        <Typography sx={{ color: "#FFD814", fontWeight: 700, fontSize: 16, mb: 0.5 }}>₹{Number(item.price || 0).toLocaleString("en-IN")}</Typography>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          {onAddToCart && (
            <Button variant="contained" size="small" onClick={() => onAddToCart(item)} sx={{ flex: 1, bgcolor: "#FFD814", color: "#000", textTransform: "none", fontWeight: 600, fontSize: 11, borderRadius: "100px", py: 0.5, minHeight: 28, "&:hover": { bgcolor: "#e6c512" } }}><ShoppingBagIcon sx={{ fontSize: 13, mr: 0.3 }} /> Cart</Button>
          )}
          <Button variant="outlined" size="small" onClick={() => onBuyProduct ? onBuyProduct(itemId) : onNavigate(`/delivery-location/${itemId}`)} sx={{ flex: 1, borderColor: "rgba(255,255,255,0.3)", color: "#fff", textTransform: "none", fontWeight: 600, fontSize: 11, borderRadius: "100px", py: 0.5, minHeight: 28, "&:hover": { borderColor: "#FFD814", color: "#FFD814" } }}>Buy</Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MobileReelCard;